(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-f-arcade"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nd-nokirumi-arcade')) {
  class NdNokirumiArcade extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.field = this.querySelector('[data-arcade-field]');
      this.dropsEl = this.querySelector('[data-arcade-drops]');
      this.effectsEl = this.querySelector('[data-arcade-effects]');
      this.collectibles = { spark: { points: 5, symbol: '✦', label: this.dataset.spark }, star: { points: 15, symbol: '★', label: this.dataset.star }, gem: { points: 25, symbol: '◆', label: this.dataset.gem }, noise: { points: -5, symbol: '≋', label: this.dataset.noise } };
      this.playerEl = this.querySelector('[data-arcade-player]');
      this.overlay = this.querySelector('[data-arcade-overlay]');
      this.overlayTitle = this.querySelector('[data-arcade-overlay-title]');
      this.overlayCopy = this.querySelector('[data-arcade-overlay-copy]');
      this.statusEl = this.querySelector('[data-arcade-status]');
      this.scoreEl = this.querySelector('[data-arcade-score]');
      this.clockEl = this.querySelector('[data-arcade-clock]');
      this.clockLabel = this.querySelector('[data-arcade-clock-label]');
      this.modeEl = this.querySelector('[data-arcade-mode]');
      this.startEl = this.querySelector('[data-arcade-start]');
      this.pauseEl = this.querySelector('[data-arcade-pause]');
      this.stopEl = this.querySelector('[data-arcade-stop]');
      this.rewardPanel = this.querySelector('[data-reward-panel]');
      this.rewardTitle = this.querySelector('[data-reward-title]');
      this.rewardProgress = this.querySelector('[data-reward-progress]');
      this.rewardClaims = Array.from(this.querySelectorAll('[data-reward-claim]'));
      this.bestRewardScore = 0;
      try {
        const saved = Number(window.sessionStorage.getItem('nd-spark-reward-v1'));
        if (Number.isInteger(saved) && saved >= 150 && saved <= 100000) this.bestRewardScore = saved;
      } catch (_) {}
      this.listeners = [];
      this.keys = new Set();
      this.frame = null;
      this.duration = 30;
      this.modeEl.value = '30';
      this.phase = 'idle';
      this.reset();
      this.listen(this.startEl, 'click', () => this.start());
      this.listen(this.pauseEl, 'click', () => this.phase === 'paused' ? this.resume() : this.pause());
      this.listen(this.stopEl, 'click', () => this.finish(true));
      this.listen(this.modeEl, 'change', () => this.changeMode());
      this.listen(this, 'keydown', event => this.keyDown(event));
      this.listen(this, 'keyup', event => { this.keys.delete(event.key.toLowerCase()); });
      this.listen(this.field, 'blur', () => { this.keys.clear(); });
      this.listen(this, 'focusout', event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.pause(); });
      this.listen(this.field, 'pointerdown', event => {
        if (this.phase !== 'playing' || event.target.closest('button')) return;
        if (this.pointerId !== null && this.pointerId !== event.pointerId) return;
        this.pointerId = event.pointerId;
        this.field.setPointerCapture?.(event.pointerId);
        this.movePointer(event);
      });
      this.listen(this.field, 'pointermove', event => {
        if (this.phase === 'playing' && (event.pointerType === 'mouse' || this.pointerId === event.pointerId)) this.movePointer(event);
      });
      const releasePointer = event => { if (this.pointerId === event.pointerId) this.pointerId = null; };
      this.listen(this.field, 'pointerup', releasePointer);
      this.listen(this.field, 'pointercancel', releasePointer);
      this.listen(this.field, 'lostpointercapture', releasePointer);
      this.querySelectorAll('[data-arcade-direction]').forEach(button => {
        const direction = Number(button.dataset.arcadeDirection);
        this.listen(button, 'pointerdown', event => {
          if (this.phase !== 'playing') return;
          event.preventDefault();
          button.setPointerCapture?.(event.pointerId);
          this.heldDirection = direction;
          this.movePlayer(this.x + direction * 10);
        });
        const release = () => { this.heldDirection = 0; };
        this.listen(button, 'pointerup', release);
        this.listen(button, 'pointercancel', release);
        this.listen(button, 'lostpointercapture', release);
        this.listen(button, 'click', event => {
          if (event.detail === 0 && this.phase === 'playing') this.movePlayer(this.x + direction * 12);
        });
      });
      this.listen(document, 'visibilitychange', () => { if (document.hidden) this.pause(); });
      this.listen(window, 'blur', () => this.pause());
      this.listen(document, 'nd:noise', event => { if (event.detail?.state === 'off') this.pause(); });
      this.listen(document, 'nd:motion', event => { if (event.detail?.state === 'reduce') this.pause(); });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.pause(); }, { threshold: 0 });
        this.observer.observe(this);
      }
      this.render();
    }
    disconnectedCallback() {
      window.NDGameSound?.stop('sparkdash');
      this.cancelFrame();
      this.scoreAnimation?.cancel();
      this.listeners?.forEach(remove => remove());
      this.observer?.disconnect();
      this.initialized = false;
    }
    listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      this.listeners.push(() => target.removeEventListener(name, handler, options));
    }
    reduceEffects() {
      return document.documentElement.dataset.noise === 'off' || document.documentElement.dataset.motion === 'reduce' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    }
    reset() {
      window.NDGameSound?.stop('sparkdash');
      this.score = 0;
      this.remaining = this.duration;
      this.x = 50;
      this.items = [];
      this.effects = [];
      this.spawnClock = 0.15;
      this.lastTime = null;
      this.heldDirection = 0;
      this.pointerId = null;
      this.keys.clear();
      this.dropsEl.replaceChildren();
      this.effectsEl.replaceChildren();
      this.movePlayer(50);
    }
    changeMode() {
      this.cancelFrame();
      this.duration = this.modeEl.value === '20' ? 20 : 30;
      this.phase = 'idle';
      this.reset();
      this.render();
      this.announce(this.dataset.ready);
    }
    start() {
      this.cancelFrame();
      this.reset();
      this.phase = 'playing';
      window.NDGameSound?.unlock();
      window.NDGameSound?.cue('start','sparkdash');
      this.render();
      this.announce(this.dataset.playing);
      this.dispatchEvent(new CustomEvent('nd:activity-start', {bubbles:true,detail:{activity:'sparkdash'}}));
      this.field.focus({ preventScroll: true });
      this.querySelector('.f-arcade__toolbar').scrollIntoView?.({ block: 'start', behavior: 'instant' });
      this.queueFrame();
    }
    queueFrame() {
      if (this.phase !== 'playing' || this.frame !== null) return;
      this.frame = requestAnimationFrame(now => {
        this.frame = null;
        const dt = this.lastTime === null ? 0 : Math.max(0, (now - this.lastTime) / 1000);
        this.lastTime = now;
        this.advance(dt);
        this.queueFrame();
      });
    }
    cancelFrame() {
      if (this.frame !== null && this.frame !== undefined) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.lastTime = null;
    }
    advance(elapsed) {
      if (this.phase !== 'playing') return;
      this.remaining = Math.max(0, this.remaining - elapsed);
      if (this.remaining === 0) { this.finish(false); return; }
      const dt = Math.min(elapsed, 0.05);
      const direction = this.heldDirection || (this.keys.has('arrowright') || this.keys.has('d') ? 1 : 0) - (this.keys.has('arrowleft') || this.keys.has('a') ? 1 : 0);
      if (direction) this.movePlayer(this.x + direction * dt * 75);
      this.spawnClock -= dt;
      if (this.spawnClock <= 0) { this.spawn(); this.spawnClock = 0.5; }
      this.items = this.items.filter(item => {
        const before = item.y;
        item.y += item.speed * dt;
        if (before < 82 && item.y >= 82 && Math.abs(item.x - this.x) < 9) {
          const points = this.collectibles[item.kind].points;
          this.score = Math.max(0, this.score + points);
          this.catchEffect(item.x, points);
          window.NDGameSound?.cue(item.kind,'sparkdash');
          item.el.remove();
          return false;
        }
        if (item.y > 110) { item.el.remove(); return false; }
        item.el.style.top = item.y + '%';
        return true;
      });
      this.effects = this.effects.filter(effect => {
        effect.age += dt;
        const progress = Math.min(1, effect.age / effect.duration);
        if (progress >= 1) { effect.el.remove(); return false; }
        if (effect.particle) {
          const ease = 1 - (1 - progress) * (1 - progress);
          const dx = effect.vx * ease;
          const dy = effect.vy * ease + 12 * progress * progress;
          effect.el.style.transform = 'translate(-50%,-50%) translate(' + dx + 'px,' + dy + 'px) rotate(' + progress * effect.spin + 'deg) scale(' + (1 - progress * 0.45) + ')';
        } else effect.el.style.transform = 'translateX(-50%) translateY(' + (-effect.age * 42) + 'px)';
        effect.el.style.opacity = String(Math.max(0, 1 - progress));
        return true;
      });
      this.updateCounters();
    }
    catchEffect(x, points) {
      if (this.reduceEffects()) return;
      const el = document.createElement('span');
      el.className = 'f-arcade__catch' + (points < 0 ? ' f-arcade__catch--noise' : '');
      el.textContent = (points > 0 ? '✧ +' : '') + points;
      el.style.left = x + '%';
      el.style.top = '77%';
      this.addEffect({ el, age: 0, duration: 0.85 });
      if (points <= 0) return;
      this.scoreAnimation?.cancel();
      this.scoreAnimation = this.scoreEl.animate?.([
        { transform: 'scale(1)' },
        { transform: 'scale(1.14)', offset: 0.4 },
        { transform: 'scale(1)' }
      ], { duration: 320, easing: 'ease-out' });
      const count = points >= 25 ? 8 : points >= 15 ? 6 : 4;
      const kind = points >= 25 ? 'gem' : points >= 15 ? 'star' : 'spark';
      for (let i = 0; i < count; i += 1) {
        const particle = document.createElement('span');
        particle.className = 'f-arcade__particle f-arcade__particle--' + kind;
        particle.textContent = i % 2 ? '✧' : '✦';
        particle.style.left = x + '%';
        particle.style.fontSize = (7 + i % 3 * 2) + 'px';
        const angle = -Math.PI + i / (count - 1) * Math.PI;
        this.addEffect({ el: particle, age: 0, duration: 0.65 + i % 3 * 0.06, particle: true,
          vx: Math.cos(angle) * (20 + i % 3 * 9),
          vy: Math.sin(angle) * (25 + i % 3 * 10) - 12,
          spin: i % 2 ? 65 : -65 });
      }
    }
    addEffect(effect) {
      if (this.effects.length >= 40) this.effects.shift().el.remove();
      this.effectsEl.append(effect.el);
      this.effects.push(effect);
    }
    spawn() {
      const roll = Math.random();
      const kind = roll < 0.18 ? 'noise' : roll < 0.55 ? 'spark' : roll < 0.83 ? 'star' : 'gem';
      const el = document.createElement('span');
      el.className = 'f-arcade__drop f-arcade__drop--' + kind;
      const icon = document.createElement('span');
      icon.className = kind === 'noise' ? 'f-arcade__noise-symbol' : 'f-arcade__collectible';
      icon.textContent = this.collectibles[kind].symbol;
      el.append(icon);
      if (kind !== 'noise') {
        const trail = document.createElement('span');
        trail.className = 'f-arcade__trail';
        trail.textContent = '✦';
        el.append(trail);
      }
      const item = { kind, el, x: 9 + Math.random() * 82, y: -8, speed: 32 + Math.random() * 10 };
      el.style.left = item.x + '%';
      el.style.top = item.y + '%';
      this.dropsEl.append(el);
      this.items.push(item);
    }
    movePlayer(value) {
      this.x = Math.min(91, Math.max(9, value));
      this.playerEl.style.left = this.x + '%';
    }
    movePointer(event) {
      const rect = this.field.getBoundingClientRect();
      if (rect.width > 0) this.movePlayer((event.clientX - rect.left) / rect.width * 100);
    }
    keyDown(event) {
      if (this.phase !== 'playing' || event.target !== this.field) return;
      const key = event.key.toLowerCase();
      if (['arrowleft', 'arrowright', 'a', 'd'].includes(key)) { event.preventDefault(); this.keys.add(key); }
      if (key === ' ' || key === 'escape') { event.preventDefault(); this.pause(); }
    }
    pause() {
      if (this.phase !== 'playing') return;
      this.phase = 'paused';
      window.NDGameSound?.stop('sparkdash');
      this.keys.clear();
      this.heldDirection = 0;
      this.pointerId = null;
      this.cancelFrame();
      this.render();
      this.announce(this.dataset.paused);
    }
    resume() {
      if (this.phase !== 'paused') return;
      window.NDGameSound?.unlock();
      this.phase = 'playing';
      this.render();
      this.announce(this.dataset.playing);
      this.field.focus({ preventScroll: true }); this.queueFrame();
    }
    finish(stopped) {
      if (this.phase === 'idle' || this.phase === 'finished') return;
      this.cancelFrame();
      this.phase = 'finished';
      this.keys.clear();
      this.heldDirection = 0;
      this.pointerId = null;
      this.stopped = stopped;
      window.NDGameSound?.stop('sparkdash');
      if(!stopped){window.NDGameSound?.cue('finish','sparkdash');if(this.score>=150)window.NDGameSound?.applaud('sparkdash');}
      if (this.score >= 150) {
        this.bestRewardScore = Math.max(this.bestRewardScore, this.score);
        try { window.sessionStorage.setItem('nd-spark-reward-v1', String(this.bestRewardScore)); } catch (_) {}
      }
      this.render();
      this.dispatchEvent(new CustomEvent('nd:activity-finish', {bubbles:true,detail:{activity:'sparkdash'}}));
      this.announce(this.resultText() + (this.rewardPanel && !this.rewardPanel.hidden ? ' ' + this.rewardTitle.textContent : ''));
      if (this.rewardPanel && !this.rewardPanel.hidden) this.rewardTitle.focus({ preventScroll: true });
      else this.startEl.focus({ preventScroll: true });
    }
    renderRewards() {
      if (!this.rewardPanel || this.dataset.rewardReady !== 'true') return;
      const tier = this.bestRewardScore >= 250 ? 250 : this.bestRewardScore >= 200 ? 200 : this.bestRewardScore >= 150 ? 150 : 0;
      const canClaim = tier > 0 && this.phase !== 'playing' && this.phase !== 'paused';
      this.rewardPanel.hidden = !canClaim;
      this.rewardProgress.hidden = canClaim;
      const remaining = Math.max(0, 150 - this.score);
      this.rewardProgress.textContent = remaining ? this.dataset.rewardLocked.replace('{remaining}', String(remaining)) : '';
      this.querySelectorAll('[data-reward-tier]').forEach(item => item.classList.toggle('is-unlocked', Number(item.dataset.rewardTier) <= Math.max(this.score, this.bestRewardScore)));
      if (tier) {
        this.rewardTitle.textContent = ({ 150: this.dataset.rewardKitTitle, 200: this.dataset.rewardChoiceTitle, 250: this.dataset.rewardBothTitle })[tier];
        this.querySelector('[data-reward-best]').textContent = this.dataset.rewardBest.replace('{score}', String(this.bestRewardScore));
      }
      this.rewardClaims.forEach(link => {
        const kind = link.dataset.rewardClaim;
        const allowed = canClaim && (tier === 250 ? kind === 'both' : tier === 200 ? kind === 'time' : kind === 'kit');
        link.hidden = !allowed;
        if (allowed) link.setAttribute('href', this.dataset[kind + 'Checkout']);
        else link.removeAttribute('href');
      });
    }
    resultText() {
      return this.dataset.result.replace('{score}', String(this.score));
    }
    announce(text) {
      if (this.statusEl.textContent !== text) this.statusEl.textContent = text;
    }
    updateCounters() {
      this.scoreEl.textContent = String(this.score);
      this.renderRewards();
      this.clockEl.textContent = Math.ceil(this.remaining) + 's';
    }
    render() {
      const active = this.phase === 'playing';
      const paused = this.phase === 'paused';
      const finished = this.phase === 'finished';
      const hint = window.matchMedia?.('(max-width: 760px)').matches && this.dataset.touchHint ? this.dataset.touchHint : this.dataset.quickHint;
      this.classList.toggle('is-running', active);
      this.classList.toggle('is-paused', paused);
      this.classList.toggle('is-finished', finished);
      if (!active) {
        this.effects = [];
        this.effectsEl.replaceChildren();
        this.scoreAnimation?.cancel();
        this.scoreAnimation = null;
      }
      this.overlay.hidden = active;
      this.dropsEl.hidden = false;
      this.playerEl.hidden = !active;
      this.querySelector('[data-arcade-arrows]').hidden = !active;
      this.startEl.hidden = active || paused;
      this.startEl.textContent = finished ? this.dataset.replay : this.dataset.start;
      this.pauseEl.hidden = !active && !paused;
      this.pauseEl.textContent = paused ? this.dataset.resume : this.dataset.pause;
      this.stopEl.hidden = !active && !paused;
      this.overlayTitle.textContent = paused ? this.dataset.paused : finished ? (this.stopped ? this.dataset.stopped : this.dataset.finished) : this.dataset.ready;
      this.overlayCopy.textContent = finished ? this.resultText() : paused ? this.dataset.pausedCopy : this.dataset.readyCopy;
      this.querySelector('[data-arcade-hint]').textContent = hint;
      this.clockLabel.textContent = this.dataset.time;
      this.updateCounters();
    }
  }
  customElements.define('nd-nokirumi-arcade', NdNokirumiArcade);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-f-brain-storm"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nd-brain-storm')) {
  class NdBrainStorm extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.steps = Array.from(this.querySelectorAll('[data-brain-step]'));
      this.resultCards = Array.from(this.querySelectorAll('[data-brain-result]'));
      this.intro = this.querySelector('[data-brain-intro]');
      this.questions = this.querySelector('[data-brain-questions]');
      this.results = this.querySelector('[data-brain-results]');
      this.startButton = this.querySelector('[data-brain-start]');
      this.nextButton = this.querySelector('[data-brain-next]');
      this.backButton = this.querySelector('[data-brain-back]');
      this.retakeButton = this.querySelector('[data-brain-retake]');
      this.progressWrap = this.querySelector('[data-brain-progress-wrap]');
      this.progress = this.querySelector('[data-brain-progress]');
      this.stepCopy = this.querySelector('[data-brain-step-copy]');
      this.instruction = this.querySelector('[data-brain-instruction]');
      this.status = this.querySelector('[data-brain-status]');
      this.answers = [null, null, null];
      this.index = 0;
      this.listeners = [];
      this.kinds = ['reset', 'time', 'play'];
      this.listen(this.startButton, 'click', () => this.begin());
      this.listen(this.retakeButton, 'click', () => this.begin());
      this.listen(this.nextButton, 'click', () => this.next());
      this.listen(this.backButton, 'click', () => this.back());
      this.steps.forEach((step, index) => step.querySelectorAll('[data-brain-answer]').forEach(input => {
        this.listen(input, 'change', () => {
          if (this.phase !== 'questions' || index !== this.index || !input.checked || !this.kinds.includes(input.value)) return;
          this.answers[index] = input.value;
          this.updateChoice();
          this.announce(this.dataset.chosenCopy);
        });
      }));
      this.phase = 'intro';
      this.intro.hidden = false;
      this.questions.hidden = true;
      this.results.hidden = true;
      this.progressWrap.hidden = true;
      this.steps.forEach(step => { step.hidden = true; });
      this.resultCards.forEach(card => { card.hidden = true; });
      this.classList.remove('has-started');
      this.status.textContent = '';
      this.startButton.hidden = false;
      this.querySelector('[data-brain-fallback]').hidden = true;
    }
    disconnectedCallback() {
      this.listeners?.forEach(remove => remove());
      this.initialized = false;
    }
    listen(target, name, handler) {
      target.addEventListener(name, handler);
      this.listeners.push(() => target.removeEventListener(name, handler));
    }
    announce(text) {
      if (this.status.textContent !== text) this.status.textContent = text;
    }
    begin() {
      this.answers = [null, null, null];
      this.index = 0;
      this.phase = 'questions';
      this.intro.hidden = true;
      this.results.hidden = true;
      this.resultCards.forEach(card => { card.hidden = true; });
      this.questions.hidden = false;
      this.progressWrap.hidden = false;
      this.classList.add('has-started');
      this.showStep();
    }
    showStep() {
      this.steps.forEach((step, index) => {
        step.hidden = index !== this.index;
        step.querySelectorAll('[data-brain-answer]').forEach(input => { input.checked = input.value === this.answers[index]; });
      });
      const text = this.dataset.stepCopy.replace('{step}', String(this.index + 1));
      this.stepCopy.textContent = text;
      this.progress.value = this.index;
      this.progress.setAttribute('aria-valuetext', text);
      this.backButton.hidden = this.index === 0;
      this.nextButton.textContent = this.index === 2 ? this.dataset.revealCopy : this.dataset.nextCopy;
      this.updateChoice();
      this.announce(text);
      this.steps[this.index].querySelector('[data-brain-question-title]').focus({ preventScroll: true });
      this.progressWrap.scrollIntoView?.({ block: 'start', behavior: 'instant' });
    }
    updateChoice() {
      const chosen = this.kinds.includes(this.answers[this.index]);
      this.nextButton.disabled = !chosen;
      this.instruction.textContent = chosen ? this.dataset.chosenCopy : this.dataset.chooseCopy;
    }
    next() {
      if (this.phase !== 'questions' || !this.kinds.includes(this.answers[this.index])) return;
      if (this.index < 2) { this.index += 1; this.showStep(); }
      else this.finish();
    }
    back() {
      if (this.phase !== 'questions' || this.index === 0) return;
      this.index -= 1;
      this.showStep();
    }
    pickResult() {
      if (this.answers.some(answer => !this.kinds.includes(answer))) return null;
      const counts = { reset: 0, time: 0, play: 0 };
      this.answers.forEach(answer => { counts[answer] += 1; });
      const highest = Math.max(counts.reset, counts.time, counts.play);
      return this.answers.find(answer => counts[answer] === highest);
    }
    finish() {
      const result = this.pickResult();
      if (!result || this.phase !== 'questions') return;
      this.phase = 'result';
      this.questions.hidden = true;
      this.results.hidden = false;
      this.progress.value = 3;
      this.progress.setAttribute('aria-valuetext', this.dataset.readyCopy);
      this.stepCopy.textContent = this.dataset.readyCopy;
      this.resultCards.forEach(card => { card.hidden = card.dataset.brainResult !== result; });
      const title = this.querySelector('[data-brain-result="' + result + '"] [data-brain-result-title]');
      this.announce(this.dataset.readyCopy + ' ' + title.textContent);
      title.focus({ preventScroll: true });
      this.progressWrap.scrollIntoView?.({ block: 'start', behavior: 'instant' });
    }
  }
  customElements.define('nd-brain-storm', NdBrainStorm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-f-header"]) return;
  try {
    
document.addEventListener('click',function(event){
  document.querySelectorAll('.f-menu-disclosure[open]').forEach(function(details){
    if(!details.contains(event.target))details.open=false;
  });
  const link=event.target.closest('.f-menu-children a');
  if(!link)return;
  const drawer=link.closest('dialog');
  if(drawer&&drawer.open)drawer.close();
  link.closest('details').open=false;
});
document.addEventListener('keydown',function(event){
  if(event.key!=='Escape')return;
  const open=document.querySelector('.f-hdr__nav .f-menu-disclosure[open]');
  if(open){open.open=false;open.querySelector('summary').focus();event.preventDefault();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-f-loop-breaker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nd-loop-breaker')) {
 class NdLoopBreaker extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.tiles = Array.from(this.querySelectorAll('[data-loop-tile]'));
   this.board = this.querySelector('[data-loop-board]');
   this.overlay = this.querySelector('[data-loop-overlay]');
   this.titleEl = this.querySelector('[data-loop-title]');
   this.copyEl = this.querySelector('[data-loop-copy]');
   this.startEl = this.querySelector('[data-loop-start]');
   this.sendEl = this.querySelector('[data-loop-send]');
   this.pauseEl = this.querySelector('[data-loop-pause]');
   this.endEl = this.querySelector('[data-loop-end]');
   this.nudgeEl = this.querySelector('[data-loop-nudge]');
   this.timeEl = this.querySelector('[data-loop-time]');
   this.roundEl = this.querySelector('[data-loop-round]');
   this.scoreEl = this.querySelector('[data-loop-score]');
   this.hintsEl = this.querySelector('[data-loop-hints]');
   this.sceneEl = this.querySelector('[data-loop-scene]');
   this.statusEl = this.querySelector('[data-loop-status]');
   this.paths = [[0,1,5,6,10,11,15],[0,4,5,1,2,6,7,11,10,14,15],[0,1,5,4,8,9,10,6,2,3,7,11,15]];
   this.listeners = [];
   this.touchInteraction = false;
   this.phase = 'idle'; this.level = 0; this.score = 0; this.hints = 3; this.frame = null; this.focusIndex = 0;
   this.listen(this.startEl, 'click', () => this.phase === 'cleared' ? this.next() : this.start());
   this.listen(this.sendEl, 'click', () => this.send());
   this.listen(this.pauseEl, 'click', () => this.phase === 'paused' ? this.resume() : this.pause('button'));
   this.listen(this.endEl, 'click', () => this.end('ended'));
   this.listen(this, 'pointerdown', event => this.notePointer(event));
   this.listen(this.nudgeEl, 'pointerdown', event => {
    this.notePointer(event);
    if (this.phase === 'playing') { event.preventDefault(); event.stopPropagation(); }
   });
   this.listen(this.nudgeEl, 'click', event => {
    event.preventDefault(); event.stopPropagation(); this.nudge();
   });
   this.tiles.forEach((tile,index) => {
    this.listen(tile, 'click', () => this.rotate(index));
    this.listen(tile, 'focus', () => { this.focusIndex = index; this.updateTabStops(); });
    this.listen(tile, 'keydown', event => this.navigate(event,index));
   });
   this.listen(this, 'keydown', event => {
    if (event.key.toLowerCase() === 'p' && !event.repeat) { event.preventDefault(); this.phase === 'paused' ? this.resume() : this.pause('keyboard'); }
    if (event.key === 'Escape') this.pause('keyboard');
   });
   this.listen(this, 'focusout', event => {
    const target = event.relatedTarget;
    if (!this.touchMode() && target && target !== document.body && target !== document.documentElement && !this.contains(target)) this.pause('focus-outside');
   });
   this.listen(document, 'pointerdown', event => {
    if (!this.contains(event.target) && !event.composedPath?.().includes(this)) this.pause('outside-control');
   });
   this.listen(document, 'visibilitychange', () => { if (document.hidden) this.pause('hidden-tab'); });
   this.listen(window, 'blur', () => { if (!this.touchMode()) this.pause('window-blur'); });
   this.listen(window, 'pagehide', () => this.pause('page-hidden'));
   this.listen(document, 'nd:noise', event => { if (event.detail?.state === 'off') this.pause('noise-setting'); });
   this.listen(document, 'nd:motion', event => { if (event.detail?.state === 'reduce') this.pause('motion-setting'); });
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries => { if (!this.touchMode() && !entries[0].isIntersecting) this.pause('offscreen'); }, { threshold:0 });
    this.observer.observe(this);
   }
   this.setup(); this.render();
  }
  disconnectedCallback() {
   window.NDGameSound?.stop('loopbreaker');
   this.cancel(); this.listeners?.forEach(remove => remove()); this.observer?.disconnect(); this.initialized = false;
  }
  listen(target,name,handler) { target.addEventListener(name,handler); this.listeners.push(() => target.removeEventListener(name,handler)); }
  notePointer(event) { if (event.pointerType === 'touch' || event.pointerType === 'pen') this.touchInteraction = true; }
  touchMode() { return this.touchInteraction || !!window.matchMedia?.('(any-pointer: coarse)').matches; }
  updateHints() {
   this.hintsEl.textContent = String(this.hints);
   this.nudgeEl.setAttribute('aria-disabled',String(this.phase !== 'playing' || this.hints === 0));
   this.nudgeEl.setAttribute('aria-label',this.copy('nudge') + ': ' + this.hints);
  }
  copy(key) { return this.getAttribute('data-' + key.replaceAll('_','-')) || ''; }
  turn(mask) { return ((mask << 1) & 15) | ((mask >> 3) & 1); }
  direction(from,to) { return to === from - 4 ? 0 : to === from + 1 ? 1 : to === from + 4 ? 2 : 3; }
  setup() {
   this.cancel(); this.nudgedCell = null; this.remaining = 45; this.last = null; this.warned = false; this.focusIndex = 0;
   this.solution = new Array(16).fill(0);
   const path = this.paths[this.level];
   path.forEach((cell,i) => {
    const incoming = i === 0 ? 3 : this.direction(cell,path[i-1]);
    const outgoing = i === path.length-1 ? 1 : this.direction(cell,path[i+1]);
    this.solution[cell] = (1 << incoming) | (1 << outgoing);
   });
   this.masks = this.solution.map(value => {
    let mask = value || (Math.random() < .5 ? 5 : 3);
    const turns = Math.floor(Math.random()*4);
    for(let i=0;i<turns;i++) mask = this.turn(mask);
    return mask;
   });
   if (this.trace().complete) this.masks[0] = this.turn(this.masks[0]);
   this.renderBoard();
  }
  trace() {
   let cell = 0, incoming = 3;
   const cells = [], visited = new Set();
   for(let step=0;step<17;step++) {
    if (visited.has(cell)) return {cells,complete:false};
    visited.add(cell);
    const mask = this.masks[cell];
    if (!(mask & (1 << incoming))) return {cells,complete:false};
    cells.push(cell);
    let outgoing = -1;
    for(let d=0;d<4;d++) if (d !== incoming && (mask & (1 << d))) outgoing = d;
    if (cell === 15 && outgoing === 1) return {cells,complete:true};
    if (outgoing < 0 || (outgoing === 0 && cell < 4) || (outgoing === 1 && cell % 4 === 3) || (outgoing === 2 && cell >= 12) || (outgoing === 3 && cell % 4 === 0)) return {cells,complete:false};
    cell += [-4,1,4,-1][outgoing]; incoming = (outgoing+2)%4;
   }
   return {cells,complete:false};
  }
  renderBoard() {
   const route = this.trace();
   const names = ['north','east','south','west'].map(key => this.copy(key));
   this.tiles.forEach((tile,index) => {
    const ports = [];
    for(let d=0;d<4;d++) if (this.masks[index] & (1 << d)) ports.push(d);
    const coords = [[50,0],[100,50],[50,100],[0,50]];
    const a = coords[ports[0]], b = coords[ports[1]];
    tile.querySelector('path').setAttribute('d',`M${a[0]} ${a[1]}L50 50L${b[0]} ${b[1]}`);
    tile.setAttribute('aria-label',this.copy('tile_label').replace('__row__',String(Math.floor(index/4)+1)).replace('__col__',String(index%4+1)).replace('__ports__',ports.map(d => names[d]).join(' '+this.copy('and')+' ')));
    tile.classList.toggle('is-lit',route.cells.includes(index));
    tile.classList.toggle('is-nudged',this.nudgedCell === index);
    tile.style.setProperty('--step',String(Math.max(0,route.cells.indexOf(index))));
    tile.disabled = this.phase !== 'playing';
   });
   this.updateTabStops();
  }
  updateTabStops() { this.tiles.forEach((tile,i) => { tile.tabIndex = this.phase === 'playing' && i === this.focusIndex ? 0 : -1; }); }
  render() {
   const active = this.phase === 'playing', paused = this.phase === 'paused', cleared = this.phase === 'cleared';
   this.classList.toggle('is-playing',active); this.classList.toggle('is-cleared',cleared || this.phase === 'complete');
   this.classList.toggle('is-urgent',this.remaining <= 10 && active);
   this.overlay.hidden = active || cleared;
   this.startEl.hidden = active || paused; this.sendEl.hidden = !active;
   this.pauseEl.hidden = !(active || paused); this.endEl.hidden = !(active || paused);
   this.pauseEl.textContent = this.copy(paused ? 'resume' : 'pause');
   this.startEl.textContent = this.copy(cleared ? 'next' : this.phase === 'idle' ? 'start' : 'again');
   this.nudgeEl.hidden = !(active || paused);
   this.nudgeEl.disabled = !active;
   this.updateHints(); this.scoreEl.textContent = String(this.score);
   this.roundEl.textContent = `${this.level+1} / 3`; this.timeEl.textContent = `${Math.ceil(this.remaining)}s`;
   this.sceneEl.textContent = this.copy('scene_'+(this.level+1));
   if (!this.overlay.hidden) {
    const state = this.phase === 'idle' ? 'ready' : this.phase;
    this.titleEl.textContent = this.copy(state+'_title'); this.copyEl.textContent = this.copy(state+'_copy');
   }
   this.renderBoard();
  }
  announce(key) { this.statusEl.textContent = this.copy(key); }
  start() {
   window.NDGameSound?.stop('loopbreaker');window.NDGameSound?.unlock();window.NDGameSound?.cue('start','loopbreaker');
   this.level = 0; this.score = 0; this.hints = 3; this.phase = 'playing'; this.dataset.pauseReason = '';
   this.dispatchEvent(new CustomEvent('nd:activity-start',{bubbles:true,detail:{activity:'loopbreaker'}}));
   this.setup(); this.render(); this.announce('playing'); this.tiles[0].focus({preventScroll:true}); this.showBoard(); this.schedule();
  }
  next() {
   if (this.phase !== 'cleared') return;
   window.NDGameSound?.stop('loopbreaker');window.NDGameSound?.unlock();window.NDGameSound?.cue('start','loopbreaker');
   this.level++; this.phase = 'playing'; this.setup(); this.render(); this.announce('playing'); this.tiles[0].focus({preventScroll:true}); this.showBoard(); this.schedule();
  }
  showBoard() {
   if (window.matchMedia?.('(max-width: 760px)').matches) this.querySelector('.f-loop__toolbar').scrollIntoView?.({block:'start',behavior:'instant'});
  }
  rotate(index) {
   if (this.phase !== 'playing') return;
   const before=this.trace();
   this.nudgedCell = null; this.focusIndex = index; this.masks[index] = this.turn(this.masks[index]); this.renderBoard();
   const route=this.trace();
   window.NDGameSound?.cue(route.complete&&!before.complete?'ready':route.cells.length>before.cells.length?'connect':'turn','loopbreaker',{cells:route.cells.length});
   if (route.complete) this.announce('route_ready');
  }
  navigate(event,index) {
   if (this.phase !== 'playing') return;
   const key = event.key; let next = index;
   if (key === 'ArrowUp' && index >= 4) next -= 4;
   if (key === 'ArrowDown' && index < 12) next += 4;
   if (key === 'ArrowLeft' && index % 4 > 0) next--;
   if (key === 'ArrowRight' && index % 4 < 3) next++;
   if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(key)) { event.preventDefault(); this.tiles[next].focus({preventScroll:true}); }
  }
  send() {
   if (this.phase !== 'playing') return;
   const route=this.trace();
   if (!route.complete) { this.announce('blocked');window.NDGameSound?.cue('blocked','loopbreaker');return; }
   this.cancel(); this.score += 100 + Math.ceil(this.remaining)*2;
   this.phase = this.level === 2 ? 'complete' : 'cleared'; this.render();
   window.NDGameSound?.stop('loopbreaker');window.NDGameSound?.cue(this.phase==='complete'?'win':'clear','loopbreaker',{cells:route.cells.length});
   if(this.phase==='complete')window.NDGameSound?.applaud('loopbreaker');
   if (this.phase === 'complete') this.dispatchEvent(new CustomEvent('nd:activity-finish',{bubbles:true,detail:{activity:'loopbreaker'}}));
   this.announce(this.phase === 'complete' ? 'complete_copy' : 'cleared'); this.startEl.focus({preventScroll:true});
  }
  nudge() {
   if (this.phase !== 'playing') return;
   if (this.hints === 0) { this.announce('no_nudges'); return; }
   const cell = this.paths[this.level].find(i => this.masks[i] !== this.solution[i]);
   if (cell === undefined) { this.announce('route_ready'); return; }
   this.masks[cell] = this.solution[cell]; this.hints--; this.focusIndex = cell; this.nudgedCell = cell;
   this.renderBoard(); this.updateHints(); this.announce('nudged');
   window.NDGameSound?.cue('nudge','loopbreaker');
  }
  pause(reason = 'manual') {
   if (this.phase !== 'playing') return;
   window.NDGameSound?.stop('loopbreaker');
   this.cancel(); this.phase = 'paused'; this.dataset.pauseReason = reason; this.render(); this.announce('paused_copy');
  }
  resume() {
   if (this.phase !== 'paused') return;
   window.NDGameSound?.unlock();
   this.phase = 'playing'; this.dataset.pauseReason = ''; this.last = null; this.render(); this.announce('playing'); this.tiles[this.focusIndex].focus({preventScroll:true}); this.schedule();
  }
  end(state) {
   if (!['playing','paused'].includes(this.phase)) return;
   window.NDGameSound?.stop('loopbreaker');
   if(state==='expired')window.NDGameSound?.cue('end','loopbreaker');
   this.cancel(); this.phase = state; this.render(); this.dispatchEvent(new CustomEvent('nd:activity-finish',{bubbles:true,detail:{activity:'loopbreaker'}})); this.announce(state+'_copy'); this.startEl.focus({preventScroll:true});
  }
  schedule() { if (this.frame === null && this.phase === 'playing') this.frame = requestAnimationFrame(now => this.tick(now)); }
  tick(now) {
   this.frame = null;
   if (this.phase !== 'playing') return;
   if (this.last !== null) this.remaining = Math.max(0,this.remaining-(now-this.last)/1000);
   this.last = now; this.timeEl.textContent = `${Math.ceil(this.remaining)}s`;
   this.classList.toggle('is-urgent',this.remaining <= 10);
   if (this.remaining <= 0) { this.end('expired'); return; }
   if (this.remaining <= 10 && !this.warned) { this.warned = true; this.announce('ten'); }
   this.schedule();
  }
  cancel() { if (this.frame !== null) cancelAnimationFrame(this.frame); this.frame = null; this.last = null; }
 }
 customElements.define('nd-loop-breaker',NdLoopBreaker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-f-main-product"]) return;
  try {
    
(() => {
  const init = root => root.querySelectorAll('[data-f-prod-sec]').forEach(section => {
    const dialog = section.querySelector('[data-f-gallery-dialog]');
    const links = [...section.querySelectorAll('[data-f-gallery-open]')];
    if (!dialog || !links.length || dialog.dataset.ready || !dialog.showModal) return;
    dialog.dataset.ready = 'true';
    const img = dialog.querySelector('[data-f-gallery-image]');
    const stage = dialog.querySelector('[data-f-gallery-stage]');
    const zoom = dialog.querySelector('[data-f-gallery-zoom]');
    let index = 0, opener, oldOverflow = '', start;
    const resetZoom = () => { stage.classList.remove('is-zoomed'); zoom.setAttribute('aria-pressed', 'false'); stage.scrollTo(0,0); };
    const show = i => {
      index = (i + links.length) % links.length;
      const source = links[index].querySelector('img');
      const url = new URL(source.getAttribute('src') || links[index].href, location.href);
      url.searchParams.set('width', '2400');
      img.src = url.href; img.alt = source.alt;
      dialog.querySelector('[data-f-gallery-caption]').textContent = source.alt;
      dialog.querySelector('[data-f-gallery-count]').textContent = `${index + 1} / ${links.length}`;
      resetZoom();
    };
    const toggleZoom = () => { const on = stage.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', String(on)); if (!on) stage.scrollTo(0,0); };
    links.forEach((link,i) => link.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); opener=link; show(i); oldOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden'; dialog.showModal();
    }));
    dialog.querySelector('[data-f-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-f-gallery-prev]').addEventListener('click', () => show(index-1));
    dialog.querySelector('[data-f-gallery-next]').addEventListener('click', () => show(index+1));
    zoom.addEventListener('click', toggleZoom);
    img.addEventListener('click', toggleZoom);
    dialog.addEventListener('close', () => { document.documentElement.style.overflow=oldOverflow; resetZoom(); opener?.focus({preventScroll:true}); });
    dialog.addEventListener('click', event => { if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();} });
    dialog.addEventListener('keydown', event => { if(stage.classList.contains('is-zoomed')) return; if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);} });
    stage.addEventListener('touchstart', event => { start=event.touches.length===1&&!stage.classList.contains('is-zoomed')?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null; }, {passive:true});
    stage.addEventListener('touchend', event => {if(!start||!event.changedTouches.length)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>70&&Math.abs(dx)>Math.abs(dy)*1.5)show(index+(dx<0?1:-1));}, {passive:true});
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document)); else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd-f-play-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nd-play-hub')) {
 class NdPlayHub extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true; this.listeners = []; this.games = new Map(); this.request = 0;
   this.designMode = Boolean(window.Shopify?.designMode);
   this.dialog = this.querySelector('[data-play-dialog]'); this.stage = this.querySelector('[data-play-games]');
   this.picker = this.querySelector('[data-play-picker]'); this.back = this.querySelector('[data-play-back]');
   this.titleEl = this.querySelector('[data-play-title]'); this.pickerTitle = this.titleEl.textContent;
   this.viewport = this.querySelector('[data-play-viewport]'); this.status = this.querySelector('[data-play-status]');
   const boot = () => {
    if (!this.isConnected) return;
    const map = {sparkdash:['#arcade','nd-nokirumi-arcade'],brainstorm:['#brain-storm','nd-brain-storm'],loopbreaker:['#loop-breaker','nd-loop-breaker'],bingo:['#bingo','nd-woni-bingo']};
    Object.entries(map).forEach(([id,[selector,tag]]) => {
     const section = document.querySelector(selector); if (!section) return;
     const wrapper = section.closest('.shopify-section') || section;
     const label = this.querySelector('[data-play-select="'+id+'"] [data-play-label]').textContent;
     if (!this.designMode) {
      wrapper.hidden = true;
      this.stage.append(wrapper);
     }
     wrapper.dataset.playActivity = id;
     this.games.set(id,{wrapper,section,tag,label});
    });
    this.dataset.ready = 'true';
    const hash = location.hash;
    const id = {'#arcade':'sparkdash','#brain-storm':'brainstorm','#loop-breaker':'loopbreaker','#bingo':'bingo'}[hash];
    if (id) this.openActivity(id,false);
    else if(hash==='#all-games')this.openPicker();
   };
   if (document.readyState === 'loading') this.listen(document,'DOMContentLoaded',boot,{once:true}); else boot();
   this.listen(document,'click',event => {
    const button = event.target.closest?.('[data-play-select]');
    if (button && this.contains(button)) { event.preventDefault(); this.openActivity(button.dataset.playSelect,false); return; }
    const anchor = event.target.closest?.('a[href]'); if (!anchor || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (anchor.matches('[data-play-quick]') && this.contains(anchor)) { event.preventDefault(); this.openActivity('sparkdash',true); return; }
    if (anchor.matches('[data-play-picker-open]') && this.contains(anchor)) { event.preventDefault(); this.openPicker(); return; }
    const target = new URL(anchor.href,location.href);
    if (target.origin !== location.origin || target.pathname.replace(/\/$/,'') !== location.pathname.replace(/\/$/,'')) return;
    const id = {'#arcade':'sparkdash','#brain-storm':'brainstorm','#loop-breaker':'loopbreaker','#bingo':'bingo'}[target.hash];
    if (id && this.games.has(id)) { event.preventDefault(); this.openActivity(id,false); }
    else if (anchor.hasAttribute('data-play-menu')) { event.preventDefault(); this.openPicker(); }
    else if (this.dialog.open && target.hash && document.getElementById(target.hash.slice(1)) && !this.dialog.contains(document.getElementById(target.hash.slice(1)))) this.close();
   });
   this.listen(this.back,'click',()=>this.openPicker());
   this.listen(this.querySelector('[data-play-close]'),'click',()=>this.close());
   this.listen(this.dialog,'cancel',event=>{event.preventDefault();this.close();});
   this.listen(this.dialog,'close',()=>this.closed());
   if (this.designMode) this.listen(document,'shopify:section:select',event=>{if(!this.contains(event.target))this.close();});
   this.listen(this,'nd:activity-start',event=>{const section=event.target.closest('section');const shop=section?.querySelector('[data-play-shop]');if(shop)shop.hidden=true;});
   this.listen(this,'nd:activity-finish',event=>{
    const section=event.target.closest('section'); const shop=section?.querySelector('[data-play-shop]');if(!shop)return;
    shop.hidden=false;
    const reward=section.querySelector('[data-reward-panel]');
    if(this.dialog.open && !(reward&&!reward.hidden)) shop.scrollIntoView?.({block:'nearest',behavior:'instant'});
   });
  }
  disconnectedCallback() { this.pauseCurrent();if(this.dialog?.open)this.dialog.close();document.documentElement.classList.remove('nd-play-open');this.listeners?.forEach(fn=>fn());this.initialized=false; }
  listen(target,name,handler,options) { target.addEventListener(name,handler,options);this.listeners.push(()=>target.removeEventListener(name,handler,options)); }
  pauseCurrent() { window.NDGameSound?.stop();const item=this.games.get(this.current);const game=item?.section.querySelector(item.tag);if(game?.phase==='playing')game.pause?.('play-navigation'); }
  openDialog() {
   if(this.dialog.open)return;
   this.opener=document.activeElement;this.savedScroll=window.scrollY;
   document.querySelectorAll('dialog[open]').forEach(dialog=>{if(dialog!==this.dialog)dialog.close();});
   document.dispatchEvent(new CustomEvent('nd:play-open'));
   document.documentElement.classList.add('nd-play-open');this.dialog.showModal();
  }
  openPicker() {
   this.request++;this.pauseCurrent();this.current=null;this.openDialog();this.dialog.classList.add('is-picking');
   if (!this.designMode) this.games.forEach(item=>{item.wrapper.hidden=true;});this.picker.hidden=false;this.back.hidden=true;this.titleEl.textContent=this.pickerTitle;
   this.status.textContent='';this.status.classList.add('f-sr');this.viewport.scrollTop=0;this.querySelector('[data-play-select]').focus({preventScroll:true});
  }
  async openActivity(id,quick) {
   const item=this.games.get(id);if(!item)return;
   if (this.designMode) {
    this.close();
    this.current=id;
    item.wrapper.hidden=false;
    item.section.scrollIntoView?.({block:'start',behavior:'instant'});
    return;
   }
   this.pauseCurrent();this.openDialog();const token=++this.request;
   this.status.classList.remove('f-sr');this.status.textContent=this.dataset.loading;
   let timer;
   try {
    await Promise.race([customElements.whenDefined(item.tag),new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('unavailable')),8000);})]);
   } catch (_) { if(token===this.request)this.status.textContent=this.dataset.unavailable;return; }
   finally { clearTimeout(timer); }
   if(token!==this.request||!this.dialog.open)return;
   this.dialog.classList.remove('is-picking');
   this.games.forEach(entry=>{entry.wrapper.hidden=entry!==item;});this.current=id;this.picker.hidden=true;this.back.hidden=false;this.titleEl.textContent=item.label;
   this.status.textContent='';this.status.classList.add('f-sr');this.viewport.scrollTop=0;
   const game=item.section.querySelector(item.tag);
   const shop=item.section.querySelector('[data-play-shop]');if(shop)shop.hidden=!(['finished','complete','expired','ended','result'].includes(game.phase)||game.completedBefore);
   if(id==='sparkdash' && ['idle','finished'].includes(game.phase)) {game.modeEl.value='20';game.changeMode();}
   if(quick && id==='sparkdash') { if(game.phase==='paused')game.resume();else game.start(); }
   else this.back.focus({preventScroll:true});
  }
  close() { this.request++;this.pauseCurrent();if(this.dialog.open)this.dialog.close(); }
  closed() {
   this.request++;this.pauseCurrent();document.documentElement.classList.remove('nd-play-open');document.dispatchEvent(new CustomEvent('nd:play-close'));
   if(typeof this.savedScroll==='number')window.scrollTo?.({top:this.savedScroll,behavior:'instant'});
   if(this.opener?.isConnected)this.opener.focus({preventScroll:true});
  }
 }
 customElements.define('nd-play-hub',NdPlayHub);
}

  } catch(e) { console.error(e); }
})();
})();
